import { z } from 'zod';

const envSchema = z.object({
    REACT_APP_APP_ID: z.string().optional(),
    REACT_APP_ONBOARDING_API: z.string().optional(),
    REACT_APP_API_PLATFORM: z.string().optional(),
    REACT_APP_X_API_KEY: z.string().optional(),
});

const env = envSchema.parse(process.env);

export const {
    REACT_APP_APP_ID,
    REACT_APP_ONBOARDING_API,
    REACT_APP_API_PLATFORM,
    REACT_APP_X_API_KEY,
} = env;